import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box, Checkbox, Divider, Stack, Typography } from '@mui/material';
import { ListChildComponentProps } from 'react-window';

interface SlackOutboundCardAutocompleteVirtualListRowProps {
  VirtualListRowProps: ListChildComponentProps;
  createdByUserID?: string;
}

export const SlackOutboundCardAutocompleteVirtualListRow = ({
  VirtualListRowProps,
  createdByUserID,
}: SlackOutboundCardAutocompleteVirtualListRowProps) => {
  const { data, index, style } = VirtualListRowProps;
  const rowComponent = data[index];

  if (!rowComponent) {
    return <></>;
  }

  const inlineStyle = {
    ...style,
    top: style.top as number,
    listStyleType: 'none',
  };
  const props = rowComponent[0];
  const option = rowComponent[1];
  const { selected } = rowComponent[2];
  const isPrivateReportingOption = option.id === createdByUserID;

  return (
    <Box style={{ padding: '2px', ...inlineStyle }} {...props}>
      <Box component="li" width="100%">
        <Stack alignItems="center" direction="row">
          <Checkbox size="small" checked={selected} />
          {isPrivateReportingOption ? (
            <Stack mt={1} width="100%">
              <Typography variant="body1">Send it privately to me</Typography>
              <Box sx={{ opacity: 0.5 }}>
                <Typography variant="body1">{option.name}</Typography>
              </Box>
              <Divider sx={{ my: 1, opacity: 0.2, width: '100%' }} />
            </Stack>
          ) : (
            <Stack direction="row" alignItems="center" spacing={0.5}>
              {option.isPrivate ? (
                <LockOutlinedIcon fontSize="small" />
              ) : (
                <Typography variant="body1">#</Typography>
              )}
              <Typography variant="body1">{option.name}</Typography>
            </Stack>
          )}
        </Stack>
      </Box>
    </Box>
  );
};
